import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useEmployeeSetupHintModal = (employeeId: string | null) => {
  const [isHintModalOpen, setIsHintModalOpen] = useState(false);
  const [params] = useSearchParams();

  const handleCloseHintModal = () => {
    setIsHintModalOpen(false);
  };

  useEffect(() => {
    const shouldShowHint = params.get('showEmployeeSetupDialog') === 'true';

    if (shouldShowHint && employeeId) {
      setIsHintModalOpen(true);
    }
  }, [params, employeeId]);

  return {
    isHintModalOpen,
    closeHintModal: handleCloseHintModal,
  };
};
